export default __webpack_public_path__ + "static/media/history_1980_02.514b2a61.png";